/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-sale-credit.reducer';

export const PharmacySaleCredit = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacySaleCreditList = useAppSelector(state => state.pharmacySaleCredit.entities);
  const loading = useAppSelector(state => state.pharmacySaleCredit.loading);
  const totalItems = useAppSelector(state => state.pharmacySaleCredit.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-sale-credit-heading" data-cy="PharmacySaleCreditHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.home.title">Pharmacy Sale Credits</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-sale-credit/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.home.createLabel">Create new Pharmacy Sale Credit</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacySaleCredit.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacySaleCreditList && pharmacySaleCreditList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('totalAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.totalAmount">Total Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalAmount')} />
                </th>
                <th className="hand" onClick={sort('paidAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.paidAmount">Paid Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paidAmount')} />
                </th>
                <th className="hand" onClick={sort('pendingAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.pendingAmount">Pending Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pendingAmount')} />
                </th>
                <th className="hand" onClick={sort('creditType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.creditType">Credit Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('creditType')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('closureStatus')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.closureStatus">Closure Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('closureStatus')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('cancelledReason')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.cancelledReason">Cancelled Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cancelledReason')} />
                </th>
                <th className="hand" onClick={sort('billNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.billNumber">Bill Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billNumber')} />
                </th>
                <th className="hand" onClick={sort('amended')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.amended">Amended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amended')} />
                </th>
                <th className="hand" onClick={sort('preGst')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.preGst">Pre Gst</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preGst')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.pharmacy">Pharmacy</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.consumer">Consumer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.salePayment">Sale Payment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.refundPayment">Refund Payment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.amendedFrom">Amended From</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.amendedTo">Amended To</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.invoiceType">Invoice Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.urType">Ur Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.saleBill">Sale Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacySaleCreditList.map((pharmacySaleCredit, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-sale-credit/${pharmacySaleCredit.id}`} color="link" size="sm">
                      {pharmacySaleCredit.id}
                    </Button>
                  </td>
                  <td>{pharmacySaleCredit.totalAmount}</td>
                  <td>{pharmacySaleCredit.paidAmount}</td>
                  <td>{pharmacySaleCredit.pendingAmount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.CreditType.${pharmacySaleCredit.creditType}`} />
                  </td>
                  <td>{pharmacySaleCredit.addedById}</td>
                  <td>{pharmacySaleCredit.modifiedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ClosureStatus.${pharmacySaleCredit.closureStatus}`} />
                  </td>
                  <td>{pharmacySaleCredit.active ? 'true' : 'false'}</td>
                  <td>{pharmacySaleCredit.cursor}</td>
                  <td>{pharmacySaleCredit.timestampentry}</td>
                  <td>{pharmacySaleCredit.microSec}</td>
                  <td>{pharmacySaleCredit.lastUpdated}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacySaleCredit.addedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacySaleCredit.modifiedByType}`} />
                  </td>
                  <td>{pharmacySaleCredit.cancelledReason}</td>
                  <td>{pharmacySaleCredit.billNumber}</td>
                  <td>{pharmacySaleCredit.amended ? 'true' : 'false'}</td>
                  <td>{pharmacySaleCredit.preGst ? 'true' : 'false'}</td>
                  <td>
                    {pharmacySaleCredit.pharmacy ? (
                      <Link to={`/pharmacy/${pharmacySaleCredit.pharmacy.id}`}>{pharmacySaleCredit.pharmacy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.consumer ? (
                      <Link to={`/pharmacy-consumer/${pharmacySaleCredit.consumer.id}`}>{pharmacySaleCredit.consumer.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.patient ? (
                      <Link to={`/gluco-user/${pharmacySaleCredit.patient.id}`}>{pharmacySaleCredit.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.salePayment ? (
                      <Link to={`/pharmacy-bill-payment/${pharmacySaleCredit.salePayment.id}`}>{pharmacySaleCredit.salePayment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.refundPayment ? (
                      <Link to={`/pharmacy-refund-payment/${pharmacySaleCredit.refundPayment.id}`}>
                        {pharmacySaleCredit.refundPayment.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.amendedFrom ? (
                      <Link to={`/pharmacy-sale-credit/${pharmacySaleCredit.amendedFrom.id}`}>{pharmacySaleCredit.amendedFrom.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.amendedTo ? (
                      <Link to={`/pharmacy-sale-credit/${pharmacySaleCredit.amendedTo.id}`}>{pharmacySaleCredit.amendedTo.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.invoiceType ? (
                      <Link to={`/clinical-dictionary/${pharmacySaleCredit.invoiceType.id}`}>{pharmacySaleCredit.invoiceType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.urType ? (
                      <Link to={`/clinical-dictionary/${pharmacySaleCredit.urType.id}`}>{pharmacySaleCredit.urType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacySaleCredit.saleBill ? (
                      <Link to={`/pharmacy-bill/${pharmacySaleCredit.saleBill.id}`}>{pharmacySaleCredit.saleBill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-sale-credit/${pharmacySaleCredit.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-sale-credit/${pharmacySaleCredit.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-sale-credit/${pharmacySaleCredit.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.home.notFound">No Pharmacy Sale Credits found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacySaleCreditList && pharmacySaleCreditList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacySaleCredit;
